// 埋点 模块类型BRM
export const TRACK_MODULE_BRM = {
  // 1 纪要
  SUMMARY: {
    value: '01',
    child: {
      // 列表页点击纪要标题
      SUMMARY_TITLE: { value: 1 },
      // 筛选组件 纪要筛选组件关键字搜索
      SEARCH: { value: 2 },
      // 筛选组件 创建组合
      CREATE_COMBINATION: { value: 3 },
      // 筛选组件 点击筛选项
      FILTER: { value: 4 },
      // 筛选组件 远程搜索机构
      SEARCH_ORG: { value: 5 },
      // 筛选组件 删除已选的筛选条件（清空）
      DELETE_FILTER: { value: 6 },
      // 纪要列表 brm帮你看 按钮
      BRM_AI_BTN: { value: 7 },
      // 纪要列表点击个股标签
      CLICK_STOCK_TAG: { value: 8 },
      // 点击热门纪要标题
      HOT_SUMMARY_TITLE: { value: 9 },
      // 点击调研纪要标题
      RESEARCH_SUMMARY: {
        value: '12',
        child: {
          VIEW_NUMBER: { value: '01' }
        }
      },
      // 纪要详情页进入
      DETAIL_PAGE_ENTER: { value: 13 }
    }
  },
  // 2 研报
  RESEARCH_REPORT: {
    value: '02',
    child: {
      // 搜索框根据研报标题搜索
      RESEARCH_REPORT_TITLE: { value: 1 },
      // 筛选组件 研报筛选组件关键字搜索
      SEARCH: { value: 2 },
      // 筛选组件 创建组合
      CREATE_COMBINATION: { value: 3 },
      // 筛选组件 点击筛选项
      FILTER: { value: 4 },
      // 筛选组件 远程搜索机构
      SEARCH_ORG: { value: 5 },
      // 筛选组件 删除已选的筛选条件（清空）
      DELETE_FILTER: { value: 6 },
      // 观点
      POINT: {
        value: 7,
        child: {
          // 浏览次数
          VIEW_NUMBER: { value: 1 },
          // 查看时长
          VIEW_TIME: { value: 2 },
          //摘要
          ABSTRACT: { value: 3 },
          //原文
          ORIGIN: { value: 4 },
          //点击收藏
          CONFIRM_COLLECT: { value: 5 },
          //取消收藏
          CANCEL_COLLECT: { value: 6 }
        }
      },
      // 内资研报
      DOMESTIC: {
        value: 8,
        child: {
          // 浏览次数
          VIEW_NUMBER: { value: 1 },
          // 查看时长
          VIEW_TIME: { value: 2 },
          //摘要
          ABSTRACT: { value: 3 },
          //原文
          ORIGIN: { value: 4 },
          //点击收藏
          CONFIRM_COLLECT: { value: 5 },
          //取消收藏
          CANCEL_COLLECT: { value: 6 },
          // 保存到云文档
          SAVE_TO_CLOUD_DOC: { value: 7 },
          // 内资研报详情页进入
          DETAIL_PAGE_ENTER: { value: 8 }
        }
      },
      //外资研报
      OVERSEAS: {
        value: 9,
        child: {
          //切换标题语言
          SWITCH_LANG: { value: 1 },
          //切换排序类型
          ORDER_TYPE: { value: 2 },
          //查看翻译列表
          MY_TRANSLATE: { value: 3 },
          // 点击翻译
          CLICK_TRANSLATE: { value: 4 },
          // 浏览次数
          VIEW_NUMBER: { value: 5 },
          // 查看时长
          VIEW_TIME: { value: 6 },
          // 保存到云文档
          SAVE_TO_CLOUD_DOC: { value: 7 },
          // 外资研报详情页进入
          DETAIL_PAGE_ENTER: { value: 8 }
        }
      },
      SEARCH_MARGR: {
        value: 10,
        child: {
          POINT: { value: 1 },
          DOMESTIC: { value: 2 },
          OVERSEAS: { value: 3 },
          MINE: { value: 4 },
          HISTORY: { value: 5 }
        }
      },
      SEARCH_SORT: {
        value: 11,
        child: {
          POINT: { value: 4 },
          DOMESTIC: { value: 5 },
          OVERSEAS: { value: 6 },
          MINE: { value: 7 },
          HISTORY: { value: 8 }
        }
      },
      SEARCH_CHART: {
        value: 12,
        child: {
          CHART: {
            value: 1
          }
        }
      }
    }
  },
  // 日程
  SCHEDULE: {
    value: '03',
    child: {
      // 路演
      ROADSHOW: {
        value: 1,
        child: {
          // 日程-路演-标题
          TITLE: { value: 1 },
          // 日程-路演-看详情
          DETAIL: { value: 2 },
          // 日程-路演-查看AI转记
          AI: { value: 3 }
        }
      },
      // 调研
      RESEARCH: {
        value: 2,
        child: {
          // 日程- 调研 - 看详情
          DETAIL: { value: 1 }
        }
      },
      // 会议
      MEETING: {
        value: 3,
        child: {
          // 日程-会议-看详情
          DETAIL: { value: 1 }
        }
      },
      // 其他
      OTHER: {
        value: 4,
        child: {
          // 日程-其他-看详情
          DETAIL: { value: 1 }
        }
      },
      // 日程-新建沟通
      NEW_COMMUNICATION: { value: 5 },
      // 日程-日视图
      DAY_VIEW: { value: 6 },
      // 日程-周视图
      WEEK_VIEW: { value: 7 },
      // 日程-月视图
      MONTH_VIEW: {
        value: 8,
        child: {
          TITLE: { value: 1 }
        }
      },
      // 申请回放按钮点击
      APPLY_PLAYBACK: { value: 9 },
      // 日程-周筛选
      WEEK_FILTER: { value: 10 },
      // 日程-搜索
      SEARCH: { value: 11 },
      // 日程-日/周/月视图详情查看卡片
      VIEW_DETAIL: {
        value: 12,
        child: {
          // 日程-日/周/月视图详情-收藏
          COLLECTION: { value: 1 },
          // 日程-日/周/月视图详情-重要
          IMPORTANT: { value: 2 },
          // 日程-日/周/月视图详情-分享按钮
          SHARE: { value: 3 },
          // 日程-日/周/月视图详情-分享按钮
          COPY: { value: 4 }
        }
      },
      // 日程-点击日期组件
      DATE_COMPONENT: { value: 13 },
      // 日程-访问业绩披露页面
      PERFORMANCE_DISCLOSURE: { value: 14 },
      // 日程-访问业绩交流页面
      PERFORMANCE_COMMUNICATION: { value: 15 }
    }
  },
  // 会议
  MEETING: {
    value: '04',
    child: {
      // 顶部导航进入会议
      NAV_BUTTON: {
        value: 0
      },
      // 预定会议
      RESERVE_MEETING: {
        value: 1,
        child: {
          // 预定会议(预定成功)
          RESERVE_SUCCESS: {
            value: 1
          }
        }
      },
      // 加入会议
      JOIN_MEETING: {
        value: 2
      },
      //会议列表
      LIST: {
        value: 3,
        child: {
          // 即将召开
          WILL_SHOW: { value: 1 },
          // 即将召开入会
          WILL_SHOW_JOIN: { value: 2 },
          // 即将召开查看编辑
          WILL_SHOW_VIEW_EDIT: { value: 3 },
          // 即将召开报名审核
          WILL_SHOW_JOIN_CHECK: { value: 4 },
          // 即将召开删除
          WILL_SHOW_DELETE: { value: 5 },
          // 即将召开日期
          WILL_SHOW_DATE: { value: 6 },
          // 即将召开会议状态
          WILL_SHOW_MEETING_STATUS: { value: 7 },
          // 即将召开会议搜索
          WILL_SHOW_MEETING_SELECT: { value: 8 },
          // 历史会议
          HISTORY_MEETING: { value: 9 },
          // 历史会议导出
          HISTORY_MEETING_OUTPUT: { value: 10 },
          // 历史会议录制
          HISTORY_MEETING_RECORD: { value: 11 },
          // 历史会议纪要文档
          HISTORY_MEETING_SUMMARY_DOCU: { value: 12 },
          // 历史会议删除
          HISTORY_MEETING_DELETE: { value: 13 },
          // 历史会议参会记录
          HISTORY_MEETING_JOIN_RECORD: { value: 14 },
          // 历史会议会议详情
          HISTORY_MEETING_DETAIL: { value: 15 },
          // 历史会议报名记录
          HISTORY_MEETING_SIGN_RECORD: { value: 16 },
          // 历史会议日期
          HISTORY_MEETING_DATE: { value: 17 },
          // 历史会议搜索筛选
          HISTORY_MEETING_SEARCH_SELECT: { value: 18 },
          // 历史会议-纪要文档-查看
          HISTORY_MEETING_SUMMARY_VIEW: { value: 19 },
          // 历史会议-纪要文档-导出
          HISTORY_MEETING_SUMMARY_OUTPUT: { value: 20 },
          // 历史会议-纪要文档-重命名
          HISTORY_MEETING_SUMMARY_RENAME: { value: 21 }
        }
      },
      // 录制文件 done
      RECORD: {
        value: 4,
        child: {
          // 日期
          DATE: { value: 1 },
          // 来源
          RESOURCE: { value: 2 },
          // 查看
          VIEW: { value: 3 },
          // 下载
          DOWNLOAD: { value: 4 },
          // 删除
          DELETE: { value: 5 }
        }
      },
      // 纪要文档
      SUMMARY: {
        value: 5
      }
    }
  },
  // 发现
  FIND: {
    value: '05',
    child: {
      // 发现-路演快捷入口
      ROADSHOW_QUICK: { value: 1 },
      // 发现-纪要快捷入口
      SUMMARY_QUICK: { value: 2 },
      // 发现-研报快捷入口
      RESEARCH_REPORT_QUICK: { value: 3 },
      // 发现-问答快捷入口
      QUESTION_ANSWER_QUICK: { value: 4 },
      // 发现-关注分析师
      ANALYST_FOLLOW: { value: 5 },
      // 路演 tab
      ROADSHOW_TAB: {
        value: 6,
        child: {
          // 发现-路演tab-路演详情
          DETAIL: { value: 1 },
          // 发现-路演tab-点击个股后添加自选
          FULLCODE_FOLLOW: { value: 2 }
        }
      },
      // 纪要 tab
      SUMMARY_TAB: {
        value: 7,
        child: {
          // 发现-纪要tab-纪要详情
          DETAIL: { value: 1 },
          // 发现-纪要tab-点击个股后添加自选
          FULLCODE_FOLLOW: { value: 2 }
        }
      },
      // 研报 tab
      RESEARCH_REPORT_TAB: {
        value: 8,
        child: {
          // 发现-研报tab-研报详情
          DETAIL: { value: 1 },
          // 发现-研报tab-点击个股后添加自选
          FULLCODE_FOLLOW: { value: 2 }
        }
      },
      PROMOTE: {
        value: 9,
        child: {
          // 发现-内容推广位-点击推广图
          PROMOTE_IMG: { value: 1 }
        }
      },
      // 发现
      FINDPAGE_TAB: {
        value: 10,
        child: {
          // 发现-热门模块入口
          HOT: { value: 1 },
          // 发现-我的关注模块入口
          MYFOCUS: { value: 2 }
        }
      },
      // 发现
      FIND_TAB: {
        value: 11,
        child: {
          // 纪要-tab
          SUMMARY_TAB: { value: 1 },
          // 内资研报-tab
          REPORT_TAB: { value: 2 },
          // 外资研报-tab
          OVERSEAS_TAB: { value: 3 }
        }
      },
      // 重点公司-详情页
      REPORT_DETAIL: {
        value: 12,
        child: {
          VIEW: { value: 1 }
        }
      },
      DAILY_DETAIL: {
        value: 13,
        child: {
          VIEW: { value: 1 },
          /** 投研日报详情页-进入个股详情页 */
          VISIT_STOCK_DETAIL: { value: 2 },
          /** 投研日报详情页-加入自选 */
          STOCK_ATTENTION: { value: 3 },
          /** 投研日报列表-进入个股详情页 */
          VISIT_STOCK_DETAIL_OF_LIST: { value: 4 },
          /** 投研日报列表-加入自选 */
          STOCK_ATTENTION_OF_LIST: { value: 5 },
          /** 投研日报详情页-播报按钮点击 */
          BROADCAST_CLICK: { value: 6 },
          /** 投研日报详情页-语音播放完毕 */
          BROADCAST_PLAY_END: { value: 7 },
          /** 投研日报详情页-关闭语音播报 */
          BROADCAST_BAR_CLOSE: { value: 8 }
        }
      }
    }
  },
  // 问答
  QUESTION: {
    value: '06',
    child: {
      // 问答-模块
      MODULE_QUESTION: {
        value: 0,
        child: {
          // 问答-列表
          MENU_CLICK: { value: 1 },
          // 问答-详情
          DETAIL: { value: 2 },
          // 切换模式
          SWITCH_MODE: { value: 3 }
        }
      },
      // 问答-个股-自选
      FULLCODE_FOLLOW: { value: 1 }
    }
  },
  // 全局搜索
  GLOBAL_SEARCH: {
    value: '07',
    child: {
      // 综合
      INTEGRATED: {
        value: 1,
        child: {
          // 全局搜索-综合-纪要点击个股
          SUMMARY_FOLLOW: { value: 1 },
          // 全局搜索-综合-问答点击个股
          QUESTION_FOLLOW: { value: 2 },
          // 全局搜索-综合-股票点击详情
          STOCK_DETAIL_FOLLOW: { value: 3 },
          // 全局搜索-综合-股票添加自选
          STOCK_FOLLOW: { value: 4 },
          // 全局搜索-综合-内资研报点击个股
          RESEARCH_REPORT_FOLLOW: { value: 5 },
          // 全局搜索-综合-路演标题
          ROADSHOW_TITLE: { value: 6 },
          // 全局搜索-综合-纪要标题
          SUMMARY_TITLE: { value: 7 },
          // 全局搜索-综合-外资研报点击个股
          SUMMARY_STOCK: { value: 8 },
          // 全局搜索-综合-内资研报标题
          RESEARCH_REPORT_TITLE: { value: 9 },
          // 全局搜索-综合-外资研报标题
          RESEARCH_REPORT_STOCK: { value: 10 },
          // 全局搜索-综合-问答详情
          QUESTION_DETAIL: { value: 11 },
          // 全局搜索-综合-会议详情
          MEETING_DETAIL: { value: 12 },
          // 全局搜索-综合-智能搜索再试一次
          AI_SEARCH_AGAIN: { value: 13 },
          // 全局搜索-综合-智能搜索复制
          AI_COPY: { value: 14 },
          // 全局搜索-综合-智能搜索点赞
          AI_LIKE: { value: 15 },
          // 全局搜索-综合-智能搜索点踩
          AI_DISLIKE: { value: 16 },
          // 全局搜索-综合-分析师点击
          ANALYST_CLICK: { value: 17 },
          // 全局搜索-综合-研报图表标题/图片点击
          REPORT_CHART_TITLE_OR_PIC: { value: 18 },
          // 全局搜索-综合-研报图表研报标题点击
          REPORT_CHART_TITLE: { value: 19 },
          // 全局搜索-综合-图表弹框复制图片点击
          REPORT_CHART_COPY_PIC: { value: 20 },
          // 全局搜索-综合-图表弹窗导出图片点击
          REPORT_CHART_EXPORT_PIC: { value: 21 },
          // 全局搜索-综合-图表弹框研报标题点击
          REPORT_CHART_DIALOG_TITLE: { value: 22 },
          // 全局搜索-综合-图表弹窗上一张点击
          REPORT_CHART_DIALOG_PREV: { value: 23 },
          // 全局搜索-综合-图表弹窗下一张点击
          REPORT_CHART_DIALOG_NEXT: { value: 24 }
        }
      },
      // 纪要
      SUMMARY: {
        value: 2,
        child: {
          // 全局搜索-纪要-点击个股
          STOCK_FOLLOW: { value: 1 },
          // 全局搜索-纪要-标题
          TITLE: { value: 2 },
          // 全局搜索-纪要-快捷筛选
          QUICK_FILTER: { value: 3 },
          // 全局搜索-纪要-超级快捷筛选
          SUPER_QUICK_FILTER: { value: 4 }
        }
      },
      // 内资研报
      RESEARCH_REPORT: {
        value: 3,
        child: {
          // 全局搜索-内资研报-点击个股
          STOCK_FOLLOW: { value: 1 },
          // 全局搜索-内资研报-标题
          TITLE: { value: 2 },
          // 全局搜索-内资研报-快捷筛选
          QUICK_FILTER: { value: 3 },
          // 全局搜索-内资研报-超级快捷筛选
          SUPER_QUICK_FILTER: { value: 4 }
        }
      },
      // 问答
      QUESTION: {
        value: 4,
        child: {
          // 全局搜索-问答-点击个股
          STOCK_FOLLOW: { value: 1 },
          // 全局搜索-问答详情
          TITLE: { value: 2 }
        }
      },
      // 股票
      STOCK: {
        value: 5,
        child: {
          // 全局搜索-股票-自选
          FOLLOW: { value: 1 },
          // 全局搜索-股票-标题
          TITLE: { value: 2 }
        }
      },
      // 路演
      ROADSHOW: {
        value: 6,
        child: {
          // 全局搜索-路演-标题
          TITLE: { value: 1 },
          // 全局搜索-路演-快捷筛选
          QUICK_FILTER: { value: 2 },
          // 全局搜索-路演-超级快捷筛选
          SUPER_QUICK_FILTER: { value: 3 }
        }
      },
      // 日程
      SCHEDULE: {
        value: 7,
        child: {
          // 全局搜索-日程-详情
          DETAIL: { value: 1 },
          // 全局搜索-日程-超级快捷筛选
          SUPER_QUICK_FILTER: { value: 2 }
        }
      },
      // 会议
      MEETING: {
        value: 8,
        child: {
          // 全局搜索-会议-详情
          DETAIL: { value: 1 },
          // 全局搜索-会议-超级快捷筛选
          SUPER_QUICK_FILTER: { value: 2 }
        }
      },
      // 调研
      RESEARCH: {
        value: 9,
        child: {
          // 全局搜索-调研-点击个股
          STOCK_FOLLOW: { value: 1 },
          // 全局搜索-调研-详情
          DETAIL: { value: 2 },
          // 全局搜索-调研-超级快捷筛选
          SUPER_QUICK_FILTER: { value: 3 }
        }
      },
      // 历史搜索
      HISTORY_SEARCH: {
        value: 10,
        child: {
          // 全局搜索-历史搜索
          SEARCH: { value: 1 }
        }
      },
      // 热门热搜
      HOT_SEARCH: {
        value: 11,
        child: {
          // 全局搜索-热门热搜
          SEARCH: { value: 1 }
        }
      },
      // 研报图表
      RESEARCH_CHART: {
        value: 12,
        child: {
          // 全局搜索-研报图表-图表标题/图片
          CHART_TITLE_OR_PIC: { value: 1 },
          // 全局搜索-研报图表-研报标题
          REPORT_TITLE: { value: 2 },
          // 全局搜索-研报图表-快捷筛选
          QUICK_FILTER: { value: 3 },
          // 全局搜索-研报图表-图表弹框复制
          CHART_COPY: { value: 4 },
          // 全局搜索-研报图表-图表弹框导出
          CHART_EXPORT: { value: 5 },
          // 全局搜索-研报图表-图表弹框研报标题
          CHART_DIALOG_TITLE: { value: 6 },
          // 全局搜索-研报图表-图表弹框上一张
          CHART_DIALOG_PREV: { value: 7 },
          // 全局搜索-研报图表-图表弹框下一张
          CHART_DIALOG_NEXT: { value: 8 }
        }
      },
      // 其他
      OTHER: {
        value: 13,
        child: {
          // 全局搜索-其他-结果翻页
          RESULT_PAGE: { value: 1 },
          // 全局搜索-其他-详情查看
          VIEW_DETAIL: { value: 2 },
          // 全局搜索-其他-请求响应耗时
          REQUEST_COST_TIME: { value: 3 }
        }
      },
      // 外资研报
      OVERSEAS_REPORT: {
        value: 14,
        child: {
          // 全局搜索-外资研报-快捷筛选
          QUICK_FILTER: { value: 1 }
        }
      },
      // 点评
      COMMENT: {
        value: 15,
        child: {
          // 全局搜索-点评-快捷筛选
          QUICK_FILTER: { value: 1 }
        }
      }
    }
  },
  // 个人中心
  PERSONAL_CENTER: {
    value: '08',
    child: {
      // 我的收藏
      MY_COLLECTION: {
        value: 1,
        child: {
          // 查看路演详情
          ROADSHOW_DETAIL: { value: 1 },
          // 查看纪要详情
          SUMMARY_DETAIL: { value: 2 },
          // 查看研报详情
          REPORT_DETAIL: { value: 3 },
          //查看咨讯详情
          NEWS_DETAIL: { value: 4 }
        }
      },
      // 历史记录
      MY_HISTORY: {
        value: 2,
        child: {
          // 查看路演详情
          ROADSHOW_DETAIL: { value: 1 },
          // 查看纪要详情
          SUMMARY_DETAIL: { value: 2 },
          // 查看研报详情
          REPORT_DETAIL: { value: 3 },
          //查看咨讯详情
          NEWS_DETAIL: { value: 4 }
        }
      },
      // 用户手册
      USER_MANUAL: {
        value: 3,
        child: {
          // 点击用户手册
          CLICK: { value: 1 }
        }
      }
    }
  },
  // 菜单栏
  GLOBAL_MENU: {
    value: '014',
    child: {
      // 活动
      ACTIVITY: {
        value: 1
      },
      // 日历
      CALENDAR: {
        value: 2
      },
      // 云文档
      CLOUD_DOCUMENT: {
        value: 3
      },
      // 洞察
      INSIGHT: {
        value: 4
      },
      // 研报
      RESEARCH_REPORT: {
        value: 5
      },
      // 资讯
      NEWS: {
        value: 6
      },
      // 管理
      MANAGE: {
        value: 7
      },
      // 通讯录
      ADDRESS_BOOK: {
        value: 8
      },
      // 更多
      MORE: {
        value: 9,
        child: {
          // 更多-自定义菜单
          CUSTOM_MENU: {
            value: 1
          },
          // 更多-自定义菜单-设为默认
          SET_DEFAULT: {
            value: 2
          },
          // 更多-自定义菜单-移出常用菜单
          REMOVE_COMMON: {
            value: 3
          },
          // 更多-自定义菜单-添加常用菜单
          ADD_COMMON: {
            value: 4
          },
          // 更多-自定义菜单-重置菜单
          RESET_MENU: {
            value: 5
          }
        }
      },
      // 微信群
      WECHAT_GROUP: {
        value: 10
      },
      // SRS工作台
      SRS_WORKBENCH: {
        value: 11
      },
      // IRM工作台
      IRM_WORKBENCH: {
        value: 12
      },
      // 顶部快捷入口-我的收藏 014-13
      TOP_MY_COLLECTION: {
        value: 13
      },
      // 顶部快捷入口-消息中心 014-14
      MESSAGE_CENTER: {
        value: 14
      },
      // 顶部快捷入口-服务专员 014-15
      CUSTOMER_SERVICE: {
        value: 15
      },
      // 右侧服务专员浮窗按钮 014-16
      CUSTOMER_SERVICE_WIDGET: {
        value: 16
      },
      // 个人中心下拉菜单 014-17
      PERSONAL_CENTER_MENU: {
        value: 17,
        child: {
          // 我的收藏 014-17-1
          MY_COLLECTION: { value: 1 },
          // 历史记录 014-17-2
          HISTORY: { value: 2 },
          // 我的关注 014-17-3
          FOLLOW: { value: 3 },
          // 数据同步 014-17-4
          DATA_SYNC: { value: 4 },
          // 我的资料 014-17-5
          PROFILE: { value: 5 },
          // 服务专员 014-17-6
          CUSTOMER_SERVICE: { value: 6 },
          // 任务管理器 014-17-7
          TASK: { value: 7 },
          // MCP密钥 014-17-8
          MCP_KEY: { value: 8 },
          // 已兑换内容 014-17-9
          REDEEMED_CONTENT: { value: 9 }
        }
      }
    }
  },
  // 调研
  SURVEY: {
    value: '09',
    child: {
      // 策略会
      SELECT: {
        value: 1,
        child: {
          // 调研-策略会-筛选项
          FILTER: { value: 1 },
          // 调研-策略会-机构名称搜索
          SEARCH_ORG: { value: 2 },
          // 调研-策略会-创建组合
          CREATE_COMBINATION: { value: 3 },
          // 调研-策略会-点击组合
          CLICK_SAVED_COMBINATION: { value: 4 },
          // 调研-策略会-删除/清空筛选项
          DELETE_FILTER: { value: 5 },
          // 调研-策略会-标题
          STRATEGY_TITLE: { value: 6 },
          // 调研-策略会-搜索
          SEARCH_TITLE: { value: 7 }
        }
      },
      // 调研活动
      SURVEY: {
        value: 2,
        child: {
          // 调研-调研活动-筛选项
          FILTER: { value: 1 },
          // 调研-调研活动-机构名称搜索
          SEARCH_ORG: { value: 2 },
          // 调研-调研活动-创建组合
          CREATE_COMBINATION: { value: 3 },
          // 调研-调研活动-点击组合
          CLICK_SAVED_COMBINATION: { value: 4 },
          // 调研-调研活动-删除/清空筛选项
          DELETE_FILTER: { value: 5 },
          // 调研-调研活动-标题
          SURVEY_TITLE: { value: 6 },
          // 调研-调研活动-搜索
          SEARCH_TITLE: { value: 7 }
        }
      },
      // 调研(3)- 调研活动页：直播预告、历史回顾、全部、日期筛选
      SURVEY_VIEW_TIME: {
        value: 3,
        child: {
          // 调研活动浏览时长
          CLICK: { value: 1 },
          // 09-3-2 点击tab页签（直播预告、历史回顾、全部tab）
          CLICK_TAB: { value: 2 },
          // 09-3-3 使用日期筛选组件
          DATE_FILTER: { value: 3 },
          // 09-3-4 点击列表按钮（报名、添加日程）
          LIST_BUTTON: { value: 4 },
          // 09-3-5 点击数据标题、封面
          TITLE_COVER: { value: 5 },
          // 09-3-6 使用筛选条件
          FILTER: { value: 6 },
          // 09-3-7 使用搜索
          SEARCH: { value: 7 }
        }
      },
      // 策略会(4)- 策略会页：直播预告、历史回顾、全部、日期筛选
      STRATEGY_VIEW_TIME: {
        value: 4,
        child: {
          // 策略会活动浏览时长
          CLICK: { value: 1 },
          // 调研-策略会-机构名称搜索
          SEARCH_ORG: { value: 2 },
          // 09-4-3 点击tab页签（直播预告、历史回顾、全部tab）
          CLICK_TAB: { value: 3 },
          // 09-4-4 使用日期筛选组件
          DATE_FILTER: { value: 4 },
          // 09-4-5 列表/海报视图切换
          VIEW_SWITCH: { value: 5 },
          // 09-4-6 点击列表按钮（报名、添加日程）
          LIST_BUTTON: { value: 6 },
          // 09-4-7 点击数据标题、封面
          TITLE_COVER: { value: 7 },
          // 09-4-8 使用筛选条件
          FILTER: { value: 8 },
          // 09-4-9 使用搜索
          SEARCH: { value: 9 }
        }
      }
    }
  },
  // 登录（010）
  LOGIN: {
    value: '010',
    // 点击登录（010-1）
    BTN: {
      value: 1
    },
    // 进门登录成功（010-1）
    SUCCESS: {
      value: 1
    }
  },
  // 进门注册（028）
  REGISTER_GATE: {
    value: '028',
    // 注册成功（028-1）
    SUCCESS: {
      value: 1
    }
  },
  // 通讯录
  ADDRESS_BOOK: {
    value: '011',
    child: {
      // 内部联系人
      INTERNAL_CONTACT: {
        value: 1
      },
      // 券商研究所
      BROKERAGE_RE: {
        value: 2
      }
    }
  },
  // 发现
  DISCOVER: {
    value: '012'
  },
  // 企业管理
  ENTERPRISE_MANAGE: {
    value: '013',
    child: {
      // 成员管理
      MEMBER_MANAGE: {
        value: 1
      },
      // 成员推送
      MEMBER_PUSH: {
        value: 2
      },
      // 合作券商
      COOPERATION_BROKERAGE: {
        value: 3
      },
      // 券商会议
      BROKERAGE_MEETING: {
        value: 4
      },
      // 机构设置
      ORG_SETTING: {
        value: 5
      },
      // 合作权益
      COOPERATION: {
        value: 6
      },
      // 会议授权
      MEETING_AUTHORIZATION: {
        value: 7
      },
      // 数据统计
      DATA_STATISTICS: {
        value: 8
      }
    }
  },
  // 自选
  SELFSELECTED: {
    value: '015',
    child: {
      // 自选-个股详情
      STOCK: {
        value: 1,
        child: {
          // 概览-一级行业名称
          OVERVIEW_INDUSTRY: { value: 1 },
          // 概览-关联主题名称
          OVERVIEW_THEME: { value: 2 },
          // 概览-相对一级行业热度更多
          OVERVIEW_HOTMORE: { value: 3 },
          // 研究复盘-日线，周线，月线
          RESEARCH_CHARTDATE: { value: 4 },
          // 研究复盘-前复权
          RESEARCH_REHABILITATION: { value: 5 },
          // 研究复盘-业绩公告、重大公告、路演、调研、深度研报
          RESEARCH_DATATYPE: { value: 6 },
          // 研究复盘-叠加指标：归母净利润同比增速，营业收入同比增速，PE-TTM，PB，MA5, MA20、
          RESEARCH_LINETYPE: { value: 7 },
          // 研究复盘-分钟K线（015-1-15）
          RESEARCH_MINUTE_KLINE: { value: 15 },
          // 研究复盘-分时线（015-1-16）
          RESEARCH_TIME_SHARE: { value: 16 },
          // 查看时长
          VIEW_TIME: { value: 9 },
          // 添加可比公司
          COMPARE_COMPANY: { value: 10 },
          // 点击AI启动个股brief智能体
          CLICK_AI_START_BRIEF_AGENT: { value: 11 },
          // 自选-个股详情-深度研究-持仓基金-选择聚合维度
          CLICK_DEEP_RESEARCH_AGGREGATION: { value: 12 },
          // 自选-个股详情-深度研究-持仓基金-查看更多
          CLICK_DEEP_RESEARCH_VIEW_MORE: { value: 13 },
          // 自选-个股详情-深度研究
          CLICK_DEEP_RESEARCH: { value: 14 }
        }
      },
      // 自选-行业详情
      INDUSTRY: {
        value: 2,
        child: {
          // 查看时长
          VIEW_TIME: { value: 2 }
        }
      },
      // 自选-题材详情
      THEME: {
        value: 3,
        child: {
          // 查看时长
          VIEW_TIME: { value: 2 }
        }
      },
      // 产业链
      INDUSTRYCHAIN: {
        value: 3,
        child: {
          // 产品详情页
          PRODUCT_DETAIL: { value: 3 },
          // 题材详情页
          THEME_DETAIL: { value: 4 },
          // 题材查看时长
          THEME_VIEW_TIME: { value: 2 },
          // 产品查看时长
          PRODUCT_VIEW_TIME: { value: 5 }
        }
      },
      // 自选导航栏
      NAVMENU: {
        value: 4,
        child: {
          // 左侧导航栏自选
          MENU_CLICK: { value: 1 }
        }
      },
      // 自选热门股票
      HOTSTOCK: {
        value: '05',
        child: {
          // 全部加入自选
          ADD_ALL: {
            value: 1
          }
        }
      }
    }
  },
  // 纪要详情
  SUMMARYDETAIL: {
    value: '016',
    child: {
      LIST: {
        value: 0,
        child: {
          /** 点击纪要菜单 */
          MENU_CLICK: { value: 1 },
          /** 点击纪要列表全部 Tab */
          ALL_TAB: { value: 2 },
          /** 点击纪要列表‘海外纪要’ Tab */
          OVERSEAS_TAB: { value: 3 }
        }
      },
      // 原文
      SUMMARY: {
        value: 1,
        child: {
          // 查看会议原文
          DETAIL: { value: 1 },
          // 优化版
          SIMPLE_TAB: { value: 2 },
          // 优化版 段落播放
          SIMPLE_PLAY: { value: 3 },
          // 原版
          ORIGIN_TAB: { value: 4 },
          // 原版 段落播放
          ORIGIN_PLAY: { value: 5 },
          // 对历史数据等不分优化版原版的情况，点击段落播放
          MEETING_PLAY: { value: 6 },
          // 鼠标右键复制
          COPY_MOUSE: { value: 7 },
          // 键盘复制
          COPY_KEYBOARD: { value: 8 },
          // 搜索
          SEARCH: { value: 9 },
          // 文档收起
          HIDDEN: { value: 10 },
          // 文档展开
          EXPAND: { value: 11 },
          // 双语
          BILINGUAL: { value: 12 },
          // 中文
          CHINESE: { value: 13 },
          // 英文
          ENGLISH: { value: 14 }
        }
      },
      // AI纪要
      AI_SUMMARY: {
        value: 2,
        child: {
          // 要点总计
          INTELLIGENT_TAB: { value: 2 },
          // 文档摘要
          DOC_SUMMARY_TAB: { value: 3 },
          // 摘要图片
          DOC_SUMMARY_IMG: { value: 4 },
          // 摘要播放
          DOC_SUMMARY_PLAY: { value: 5 },
          // 章节速览
          CHAPTER_TAB: { value: 6 },
          // 章节播放
          CHAPTER_PLAY: { value: 7 },
          // 问答整理
          QUESTION_TAB: { value: 8 },
          // 问答原文
          QUESTION_PLAY: { value: 9 },
          // 数据指标
          SUMMARYDATA_TAB: { value: 10 },
          // 字体大小
          FONTSIZE: { value: 11 },
          // 鼠标右键复制
          COPY_MOUSE: { value: 12 },
          // 键盘复制
          COPY_KEYBOARD: { value: 13 },
          // 一键复制
          COPY_FULL: { value: 14 }
        }
      },
      // 文档
      DOCUMENT: {
        value: 3,
        child: {
          DOCUMENT_TAB: { value: 1 }
        }
      },
      // 相关推荐
      RECOMMEND: {
        value: 4,
        child: {
          // 相关推荐
          RECOMMEND: { value: 1 },
          // 查看推荐纪要
          RECOMMEND_SUMMARY: { value: 2 }
        }
      },
      // 纪要音频
      VIDEOPLAYER: {
        value: 5,
        child: {
          // 音频点击播放
          TOGGLEPLAY_CLICK: { value: 1 },
          // 音频空格播放
          TOGGLEPLAY_KEYBOARD: { value: 2 },
          // 快进按钮
          FORWARD_PLAY_CLICK: { value: 3 },
          // 快进右方向快捷键
          FORWARD_PLAY_KEYBOARD: { value: 4 },
          // 快退按钮
          REWIND_PLAY_CLICK: { value: 5 },
          // 快进左方向快捷键
          REWIND_PLAY_KEYBOARD: { value: 6 },
          // 观看回放
          HISTORY: { value: 7 }
        }
      },
      // 页面
      PAGE: {
        value: 6,
        child: {
          // 浏览次数
          VIEW_NUMBER: { value: 1 },
          // 查看时长
          VIEW_TIME: { value: 2 }
        }
      }
    }
  },
  // 资讯详情
  NEWS: {
    value: '017',
    child: {
      // -------------------- 资讯列表废弃埋点 --------------------
      // 宏观 tab
      OVERVIEW_TAB: { value: 1 },
      // 行业 tab
      INDUSTRY_TAB: { value: 2 },
      // 自选 tab
      ANALYST_TAB: { value: 3 },
      // 勾选展示社媒资讯
      CHECK_MEDIA: { value: 6 },
      // 取消勾选展示社媒资讯
      CANCEL_CHECK_MEDIA: { value: 7 },
      // -------------------- 资讯列表废弃埋点 --------------------

      // 浏览次数
      VIEW_NUMBER: {
        value: 4,
        child: {
          // 资讯-收藏
          COLLECTION: { value: 1 },
          // 资讯-取消收藏
          CANCEL_COLLECTION: { value: 2 },
          // 个股
          STOCK: { value: 3 }
        }
      },
      // 查看时长
      VIEW_TIME: {
        value: 5
      },
      // 精选公众号
      PUBLIC_ACCOUNT_TAB: {
        value: 8,
        child: {
          // 行业筛选
          INDUSTRY_FILTER: { value: 1 }
        }
      },
      // 财经新闻
      FINANCIAL_NEWS_TAB: {
        value: 9,
        child: {
          // 行业筛选
          INDUSTRY_FILTER: { value: 1 }
        }
      },
      // 订阅公众号
      SUBSCRIBED_PUBLIC_ACCOUNT: {
        value: 10,
        child: {
          // 行业筛选
          INDUSTRY_FILTER: { value: 1 }
        }
      },
      // 运营原创推广
      PROMOTION: {
        value: 11,
        child: {
          // 推广位入口点击
          PROMO_ENTRY: { value: 1 },
          // 推广 tab 点击
          PROMO_TAB: { value: 2 },
          // 推广列表条目点击
          PROMO_ITEM: { value: 3 }
        }
      }
    }
  },

  // 云文档
  CLOUDDOCUMENT: {
    value: '018',
    child: {
      // 我的空间
      MY_SPACE: {
        value: 1,
        child: {
          // 文件夹
          FOLDER: { value: 1 },
          // 新建笔记
          CREATE_NOTES: { value: 2 },
          // 查看笔记详情
          VIEW_NOTES: { value: 3 },
          // 重命名
          RENAME_NOTES: { value: 4 },
          // 创建副本
          CREATE_COPYE: { value: 5 },
          // 删除
          DELETE_NOTES: { value: 6 },
          // AI会记-路演icon
          ROADSHOW: { value: 7 },
          // AI会记-对比icon
          COMPARE: { value: 8 },
          // 筛选项
          FILTER_NOTES: { value: 9 },
          // 搜索
          SEARCH_NOTES: { value: 10 }
        }
      },
      // 云文档
      DOCUMENT: {
        value: 2,
        child: {
          // 上传文件
          UPLOAD: { value: 1 },
          // 新建笔记
          CREATE_NOTES: { value: 2 },
          // 新建文件夹
          CREATE_FOLDER: { value: 3 },
          // 分享
          SHARE: { value: 4 },
          // 复制链接
          COPYLINK: { value: 5 },
          // 移动到
          MOVE: { value: 6 },
          // 下载
          DOWNLOAD: { value: 7 },
          // 重命名
          RENAME: { value: 8 },
          // 删除
          DELETE: { value: 9 },
          // 详情页
          NOTE_DETAIL: { value: 10 },
          // 上传文件夹
          UPLOADFOLDER: { value: 11 },
          // 创建副本
          CREATE_COPYE: { value: 12 },
          // 创建文档
          CREATE_DOC: { value: 14 },
          // 查看文档详情
          SHIMO_DOCUMENT_DETAIL: { value: 15 },
          // 编辑文档
          SHIMO_DOCUMENT_EDIT: { value: 16 },
          // 左侧根目录点击
          ROOT_DOCUMENT_CLICK: { value: 17 },
          // 纪要页面创建笔记
          SUMMARY_DOCUMENT_CREATE: { value: 18 },
          // 新建表格
          CREATE_TABLE: { value: 20 },
          // 云文档详情查看时长
          VIEW_TIME: { value: 19 },
          // 查看历史
          SHIMO_DOCUMENT_HISTORY: { value: 21 },
          // 保存版本
          SHIMO_DOCUMENT_SAVE_VERSION: { value: 22 },
          HOME_TAB_MEETING_RECORDING: { value: 23 },
          HOME_TAB_AI_NOTE: { value: 24 },
          HOME_TAB_TRANSCRIBE: { value: 25 },
          HOME_TAB_AI_AVATAR: { value: 26 },
          HOME_TAB_WECHAT_ARCHIVE: { value: 27 },
          HOME_TAB_WECHAT_GROUP: { value: 28 }
        }
      }
    }
  },

  REMINDER: {
    value: '052',
    child: {
      START: {
        value: 36,
        child: {
          NOTIFY: {
            value: 0
          },
          JOIN: {
            value: 1
          },
          CLOSE: {
            value: 2
          },
          // 点击分身参会
          AI_NOTE: {
            value: 3
          }
        }
      }
    }
  },
  // 活动页热榜入口（产品埋点编号 1-50-89，与 SUMMARY 模块 01-* 区分）
  ACTIVITY_HOT_RANKING_ENTRY: {
    value: '1',
    child: {
      HOT_RANKING: {
        value: 50,
        child: {
          // 1-50-89 活动页-点击热榜入口
          CLICK: { value: 89 }
        }
      }
    }
  },
  // 路演热榜（产品埋点编号 89-*）
  ROADSHOW_HOT_RANKING: {
    value: '89',
    child: {
      LIST: {
        value: 1,
        child: {
          // 89-1-36 热榜列表-点击路演
          CLICK_ROADSHOW: { value: 36 }
        }
      },
      FILTER: {
        value: 35,
        child: {
          // 89-35-0 热榜-筛选
          CONFIRM: { value: 0 }
        }
      }
    }
  },
  // 活动路演（路演页面 019-1-x）
  ACTIVITY_ROADSHOW: {
    value: '019',
    child: {
      // 路演页面(1)：直播预告、历史回顾、全部、日期筛选
      PAGE: {
        value: 1,
        child: {
          // 点击页签 点击推荐/全部/A股/港股/美股页签
          TAB: { value: 1 },
          // 019-1-2 点击tab页签（直播预告、历史回顾、全部tab）
          CLICK_TAB: { value: 2 },
          // 019-1-3 使用日期筛选组件
          DATE_FILTER: { value: 3 },
          // 019-1-4 列表/海报视图切换
          VIEW_SWITCH: { value: 4 },
          // 019-1-5 点击列表按钮（AI参会、添加日程、进会、纪要、AI纪要、收藏）
          LIST_BUTTON: { value: 5 },
          // 019-1-6 点击数据标题、封面
          TITLE_COVER: { value: 6 },
          // 019-1-7 使用筛选条件
          FILTER: { value: 7 },
          // 019-1-8 使用搜索
          SEARCH: { value: 8 }
        }
      },
      // 今日路演
      TODAY_ROADSHOW: {
        value: 2,
        child: {
          // 点击“今日路演”模块中的图表会唤起侧边框，记录唤起侧边框时的侧边框标题
          ROADSHOW_CHARTS: { value: 1 },
          // 点击侧边框中的路演标题
          ROADSHOW_TITLE: { value: 2 },
          // 点击“路演分区”中的频道名称
          TAB: { value: 3 },
          // 点击“路演分区”中的路演标题或者路演状态按钮，可进入路演详情页面
          TAB_ROADSHOW_TITLE: { value: 4 },
          // 点击“路演分区”中的AI会记icon
          AI_NOTE: { value: 5 },
          // 点击“业绩交流”中的“仅看自选”按钮
          ONLY_SELF: { value: 6 },
          // 点击“业绩交流”中的路演标题或状态按钮
          EXCHANGE_TITLE: { value: 7 },
          // 点击“稍纵即逝”中的限时tab
          HIDE_TAB: { value: 8 },
          // 点击“稍纵即逝”中的限时tab下的路演标题或状态按钮
          HIDE_TITLE: { value: 9 },
          // 点击“稍纵即逝”中的无回放tab
          HIDE_NO_PLAYBACK: { value: 10 },
          // 点击“稍纵即逝”中的无回放tab下的路演标题或状态按钮
          HIDE_NO_PLAYBACK_TITLE: { value: 11 }
        }
      },
      PANEL: {
        value: 3,
        child: {
          //点击右上角”列表/日历”的视图切换或者是点击列表封面模式下的”封面/列表”切换icon
          PANEL_TYPE: { value: 1 },
          // 勾选路演的筛选项（状态、行业、特色、类型等）所有样式下的均要记录
          FILTER_CONFIG: { value: 2 },
          // 点击路演标题/路演状态按钮/路演封面，所有样式下的均要记录
          ROADSHOW_TITLE: { value: 3 },
          // 点击”路演分区”中的AI会记icon
          AI_NOTE: { value: 4 }
        }
      },
      // 详情页预约浮窗 (019-4-x)
      RESERVATION_SUCCESS: {
        value: 4,
        child: {
          // 019-4-8 勾选自动预约
          CHECK_AUTO_APPOINT: { value: 8 },
          // 019-4-9 关闭自动预约
          UNCHECK_AUTO_APPOINT: { value: 9 }
        }
      }
    }
  },
  // AI进宝
  AI_CHAT: {
    value: '020',
    child: {
      // 首页
      HOME: {
        value: 1,
        child: {
          // 点击AI进宝菜单，进入AI进宝主页
          MENU: { value: 1 },
          // 点击AI进宝侧边栏-进宝logo，进入AI进宝主页
          LOGO: { value: 2 },
          // 点击AI进宝侧边栏-新建会话，进入新会话
          NEW_SESSION: { value: 3 },
          // 点击AI进宝侧边栏-历史会话，查看历史会话页面
          HISTORY_SESSION: { value: 4 },
          // 点击进宝首页的快捷问题进行提问
          SHORTCUT_QUESTION: { value: 5 },
          // 点击顶部导航栏"聊天模式"按钮，切换至聊天模式
          SWITCH_CHAT_MODE: { value: 6 },
          // 点击顶部导航栏"任务模式"按钮，切换至任务模式
          SWITCH_TASK_MODE: { value: 7 },
          // 点击首页智能体卡片（业绩点评、公司速览、行业扫描、主题产业链、个股事件、见闻速递、调研纪要、老师看盘、新股管理、特约信息、深度报告、深度研究）
          AGENT_CARD_CLICK: { value: 8 },
          // 点击侧边栏折叠/展开按钮，控制侧边栏显隐
          TOGGLE_SIDEBAR: { value: 9 },
          // 点击侧边栏"投研大脑"模块，进入投研大脑页面
          RESEARCH_BRAIN_CLICK: { value: 10 },
          // 点击侧边栏投研大脑右侧"+"按钮，新建思维链
          CREATE_CHAIN: { value: 11 },
          // 点击侧边栏投研大脑下的精选思维链项目
          FEATURED_CHAIN_CLICK: { value: 12 },
          // 点击侧边栏"智能体"模块，展开/收起智能体列表
          TOGGLE_AGENT_LIST: { value: 13 },
          // 点击侧边栏中某条历史会话记录，跳转至该对话
          HISTORY_RECORD_CLICK: { value: 14 },
          // 点击首页/对话页面输入框下方模式切换按钮（自动/极速/推理/Pro）及模型选择
          SWITCH_DIALOG_MODE: { value: 15 },
          // 点击首页/对话页面输入框的添加附件按钮
          ADD_ATTACHMENT: { value: 16 },
          // 点击首页/对话页面发送按钮或按回车键发送提问消息
          SEND_MESSAGE: { value: 17 },
          // 点击快捷问题区域的分类Tab标签
          SWITCH_SHORTCUT_CATEGORY: { value: 18 },
          // 点击首页"投研大脑"Tab标签，查看投研大脑思维链列表
          RESEARCH_BRAIN_TAB: { value: 19 },
          // 点击首页投研大脑Tab下的思维链卡片
          CHAIN_CARD_CLICK: { value: 20 },
          // 点击首页/对话页面输入框的知识库按钮
          KNOWLEDGE_BASE_CLICK: { value: 21 },
          // 点击首页/对话页面输入框的投研大脑按钮
          RESEARCH_BRAIN_INPUT_CLICK: { value: 22 },
          // 点击首页/对话页面输入框的投研大脑按钮，选择投研大脑
          RESEARCH_BRAIN_INPUT_SELECT_CLICK: { value: 23 },
          // 进入进宝任一模式页面（聊天/研究/任务）：content 携带 entry_source（进入方式）与 target_mode（目标模式）
          ENTER_MODE: { value: 24 }
        }
      },
      // 对话页面
      SESSION: {
        value: 2,
        child: {
          // 点击复制已发送问题文本
          COPY_QUESTION: { value: 1 },
          // 点击引用用户提问问题的附件文档
          COPY_QUESTION_ATTACHMENT: { value: 2 },
          // 点击查看用户提问问题的附件文档
          VIEW_QUESTION_ATTACHMENT: { value: 3 },
          // 点击复制进宝回复答案
          COPY_ANSWER: { value: 4 },
          // 点击重新生成一次答案
          REGENERATE_ANSWER: { value: 5 },
          // 点击回答内容中的参考资料编号
          REFERENCE: { value: 6 },
          // 点击进入参考资料详情页面
          REFERENCE_DETAIL: { value: 7 },
          // 点击回答下方的点赞按钮
          ANSWER_LIKE: { value: 8 },
          // 点击回答下方的点踩按钮
          ANSWER_DISLIKE: { value: 9 },
          // 点击回答下方的"云文档"按钮
          CLOUD_DOC_BUTTON: { value: 10 },
          // 点击回答下方的推荐追问卡片
          FOLLOW_UP_CLICK: { value: 11 },
          // 点击右侧工作台中的文档卡片
          WORKBENCH_DOC_CLICK: { value: 12 },
          // 点击右侧工作台关闭按钮
          WORKBENCH_CLOSE: { value: 13 },
          // 点击右侧工作台"自动展开"开关
          WORKBENCH_AUTO_EXPAND: { value: 14 },
          // 点击回答内容中的灰色引用资料，进行溯源查看
          CITE_SOURCE_TRACE: { value: 15 },
          // 点击回答下方的分享按钮
          SHARE_ANSWER: { value: 16 },
          // 点击回答下方的导出按钮，直接导出回答内容
          EXPORT_ANSWER: { value: 17 },
          // 点击工作台"查询资料"列表的排序按钮
          WORKBENCH_SORT_CLICK: { value: 18 },
          // 点击回答目录中的折叠/展开按钮
          OUTLINE_TOGGLE: { value: 19 },
          // 点击回答目录项，快速定位到对应内容段落
          OUTLINE_NAVIGATE: { value: 20 },
          // 点击工作台中的"文件"Tab
          WORKBENCH_FILE_TAB: { value: 21 },
          // 点击工作台文件列表中的转存云文档按钮
          WORKBENCH_SAVE_TO_CLOUD: { value: 22 },
          // 点击工作台文件列表中的下载按钮
          WORKBENCH_DOWNLOAD: { value: 23 },
          // 点击回答生成过程中的搜索内容、工具调用或生成文件
          THINKING_CONTENT_CLICK: { value: 24 },
          // 点击工作台中的"工具"Tab
          WORKBENCH_TOOL_TAB: { value: 25 },
          // 在工作台工具Tab中查看MCP工具调用内容
          WORKBENCH_MCP_TOOL_VIEW: { value: 26 }
        }
      },
      // 对话历史页面
      HISTORY: {
        value: 3,
        child: {
          // 检索历史会话
          SEARCH: { value: 1 },
          // 通过历史会话跳转至对话
          JUMP_SESSION: { value: 2 },
          // 点击查看会话列表的附件文档
          VIEW_ATTACHMENT: { value: 3 },
          // 跳转至搜索会话-点击检索的对话内容
          JUMP_SEARCH_SESSION: { value: 4 },
          // 点击跳转至会话的来源
          JUMP_SOURCE_SESSION: { value: 5 },
          // 点击历史会话顶部的"来源"筛选框，并选择来源条件进行筛选
          SOURCE_FILTER: { value: 6 },
          // 点击会话列表项右侧的置顶按钮，将会话置顶或取消置顶
          PIN_SESSION: { value: 7 },
          // 点击会话列表项右侧的编辑按钮，对历史会话进行重命名
          RENAME_SESSION: { value: 8 },
          // 点击会话列表项右侧的删除按钮，删除历史会话
          DELETE_SESSION: { value: 9 }
        }
      },
      // 智能体
      AGENT: {
        value: 4,
        child: {
          // 点击进宝首页业绩点评智能体
          AGENT_PERFORMANCE_CLICK: { value: 1 },
          // 对话框直接通过@快捷键唤起业绩点评智能体
          AGENT_PERFORMANCE_SHORTCUT: { value: 2 },
          // 用户点击自定义输出风格，进入自定义输出风格状态
          CREATE_CUSTOM_STYLE: { value: 3 },
          // 用户保存自定义输出风格
          SAVE_CUSTOM_STYLE: { value: 4 },
          // 用户点击精简版本tab
          VIEW_CONCISE_VERSION: { value: 5 },
          // 用户点击完整版本tab
          VIEW_FULL_VERSION: { value: 6 },
          // 用户点击自定义风格版本tab
          VIEW_CUSTOM_VERSION: { value: 7 },
          // 用户点击精简版本复制
          COPY_CONCISE_VERSION: { value: 8 },
          // 用户点击完整版本复制
          COPY_FULL_VERSION: { value: 9 },
          // 用户点击自定义风格版本复制
          COPY_CUSTOM_VERSION: { value: 10 }
        }
      },
      // 思维链管理
      RESEARCH_BRAIN: {
        value: 5,
        child: {
          // 用户点击创建|编辑 思维链页面左侧栏中的提取思维链按钮
          EXTRACT_CHAIN: { value: 1 },
          // 用户点击思维链相关区域中的做同款按钮
          USE_CHAIN: { value: 2 },
          // 用户点击验证思维链中的快捷提问时
          QUICK_QUESTION: { value: 3 },
          // 用户查看思维链验证结果的评价明细
          RATING_DETAIL: { value: 4 },
          // 用户点击采纳AI反馈的优化建议
          ADOPT_SUGGESTION: { value: 5 },
          // 点击投研大脑页面顶部的"精选"或"我的"Tab
          SWITCH_CHAIN_TAB: { value: 6 },
          // 在投研大脑页面搜索框中搜索思维链
          SEARCH_CHAIN: { value: 7 },
          // 点击投研大脑页面的创建思维链入口
          CREATE_CHAIN_ENTRY: { value: 8 },
          // 点击投研大脑列表中的思维链卡片，打开思维链详情弹窗
          CHAIN_CARD_DETAIL: { value: 9 },
          // 点击思维链卡片上的"立即使用"按钮
          CHAIN_CARD_USE: { value: 10 },
          // 点击思维链卡片详情弹窗右上角关闭按钮
          CLOSE_CHAIN_MODAL: { value: 12 },
          // 点击思维链卡片详情弹窗底部的"立即使用"按钮
          MODAL_USE_CHAIN: { value: 13 },
          // 在思维链创建/编辑页面修改思维链名称
          EDIT_CHAIN_NAME: { value: 14 },
          // 在思维链创建/编辑页面编辑思维链描述内容
          EDIT_CHAIN_DESC: { value: 15 },
          // 在思维链创建/编辑页面切换引用范本来源类型
          SWITCH_SOURCE_TYPE: { value: 16 },
          // 在思维链创建/编辑页面点击"本地文件"上传参考文件
          UPLOAD_LOCAL_FILE: { value: 17 },
          // 在思维链创建/编辑页面点击"文本粘贴"并录入内容
          PASTE_TEXT: { value: 18 },
          // 在思维链创建/编辑页面点击"云文档"引用参考文件
          USE_CLOUD_DOC: { value: 19 },
          // 在思维链创建/编辑页面点击编辑器工具栏按钮
          EDITOR_TOOLBAR_CLICK: { value: 20 },
          // 在思维链创建/编辑页面点击右上角"完成"按钮
          COMPLETE_EDIT: { value: 21 }
        }
      },
      // 任务模式-首页
      TASK_MODE_HOME: {
        value: 6,
        child: {
          // 用户点击任务模式首页右上角"打开云电脑"按钮
          OPEN_CLOUD_PC: { value: 1 },
          // 用户点击左侧当前智能体下拉框，切换任务模式当前使用的智能体
          SWITCH_AGENT: { value: 2 },
          // 用户点击左侧"新建任务"按钮
          CREATE_TASK_ENTRY: { value: 3 },
          // 用户点击左侧菜单切换页面
          SWITCH_SIDEBAR_MENU: { value: 4 },
          // 用户点击左侧历史任务列表中的某条任务
          HISTORY_TASK_CLICK: { value: 5 },
          // 用户点击任务模式首页快捷任务卡片
          QUICK_TASK_CARD_CLICK: { value: 6 },
          // 用户点击任务模式首页轮播区域的分页/切换按钮
          CAROUSEL_SWITCH: { value: 7 },
          // 用户在任务模式首页输入框发送任务
          SEND_TASK_MESSAGE: { value: 8 },
          // 用户点击任务模式输入框左下角模型选择器切换模型
          MODEL_SWITCH: { value: 9 },
          // 用户点击任务模式首页云电脑倒计时条的"立即续费"按钮
          CLOUD_PC_RENEW_CLICK: { value: 10 }
        }
      },
      // 任务模式-技能市场
      TASK_MODE_SKILL_MARKET: {
        value: 7,
        child: {
          // 用户点击技能市场顶部Tab切换技能列表
          SKILL_TAB_SWITCH: { value: 1 },
          // 用户点击技能市场右上角"我的"筛选
          MY_SKILL_FILTER: { value: 2 },
          // 用户点击技能市场中的技能卡片
          SKILL_CARD_CLICK: { value: 3 },
          // 用户点击技能卡片右上角开关，启用或停用技能
          SKILL_TOGGLE: { value: 4 },
          // 用户点击技能市场顶部操作按钮
          SKILL_MARKET_ACTION: { value: 5 }
        }
      },
      // 任务模式-定时任务
      TASK_MODE_SCHEDULED_TASK: {
        value: 8,
        child: {
          // 用户点击定时任务页面右上角"创建任务"按钮
          CREATE_SCHEDULED_TASK: { value: 1 },
          // 用户点击定时任务卡片
          SCHEDULED_TASK_CARD_CLICK: { value: 2 },
          // 用户点击定时任务卡片上的启停开关
          SCHEDULED_TASK_TOGGLE: { value: 3 },
          // 用户点击定时任务卡片上的编辑按钮
          SCHEDULED_TASK_EDIT: { value: 4 },
          // 用户点击定时任务卡片上的删除按钮
          SCHEDULED_TASK_DELETE: { value: 5 },
          // 用户点击定时任务卡片上的「立即执行」按钮
          SCHEDULED_TASK_EXECUTE: { value: 6 }
        }
      },
      // 任务模式-应用设置-频道
      TASK_MODE_CHANNEL: {
        value: 9,
        child: {
          // 用户点击频道页面中的某个频道卡片
          CHANNEL_CARD_CLICK: { value: 1 }
        }
      },
      // 任务模式-应用设置-模型
      TASK_MODE_MODEL: {
        value: 10,
        child: {
          // 用户点击模型页面LLM配置区域的"已保存"按钮
          SAVE_LLM_CONFIG: { value: 1 },
          // 用户切换模型页面LLM配置中的提供商
          LLM_PROVIDER_SWITCH: { value: 2 },
          // 用户切换模型页面LLM配置中的模型
          LLM_MODEL_SWITCH: { value: 3 },
          // 用户点击模型页面的"添加提供商"按钮
          ADD_PROVIDER: { value: 4 },
          // 用户点击模型页面中的提供商卡片
          PROVIDER_CARD_CLICK: { value: 5 },
          // 用户点击提供商卡片底部的"模型"按钮
          PROVIDER_MODEL_MANAGE: { value: 6 },
          // 用户点击提供商卡片底部的"设置"按钮
          PROVIDER_SETTINGS: { value: 7 }
        }
      },
      // 任务模式-应用设置-Token消耗
      TASK_MODE_TOKEN: {
        value: 11,
        child: {
          // 用户在Token消耗页面切换开始时间或结束时间
          TIME_RANGE_FILTER: { value: 1 },
          // 用户点击Token消耗页面的"刷新"按钮
          REFRESH_TOKEN_DATA: { value: 2 }
        }
      },
      // 任务模式-应用设置-Agent管理
      TASK_MODE_AGENT: {
        value: 12,
        child: {
          // 用户点击Agent管理页面右上角"新建Agent"按钮
          CREATE_AGENT: { value: 1 },
          // 用户点击Agent管理列表中的某个Agent
          AGENT_ROW_CLICK: { value: 2 },
          // 用户点击Agent行中的启停开关
          AGENT_TOGGLE: { value: 3 },
          // 用户点击Agent行中的"编辑"按钮
          AGENT_EDIT: { value: 4 },
          // 用户点击Agent行中的"删除"按钮
          AGENT_DELETE: { value: 5 }
        }
      },
      // 任务模式-工作区
      TASK_MODE_WORKSPACE: {
        value: 13,
        child: {
          // 用户点击工作区右上角"上传"按钮
          WORKSPACE_UPLOAD: { value: 1 },
          // 用户点击工作区右上角"下载"按钮
          WORKSPACE_DOWNLOAD: { value: 2 },
          // 用户点击核心文件区域的"刷新"按钮
          WORKSPACE_REFRESH: { value: 3 },
          // 用户点击工作区左侧文件列表中的文件
          WORKSPACE_FILE_CLICK: { value: 4 },
          // 用户点击编辑区右上角预览开关，切换文件预览状态
          WORKSPACE_PREVIEW_TOGGLE: { value: 5 },
          // 用户点击编辑区右上角"保存"按钮
          WORKSPACE_SAVE_FILE: { value: 6 }
        }
      },
      // 研究模式-埋点
      TASK_MODE_RESEARCH: {
        value: 14,
        child: {
          // 资料库：文件/文件夹加入或移除 AI 对话（020-14-1）
          RESOURCE_LIBRARY_AI_TOGGLE: { value: 1 },
          // 资料库：删除文件或文件夹（020-14-2）
          RESOURCE_LIBRARY_DELETE: { value: 2 },
          // 资料库：点击文件打开中间编辑区 Tab（020-14-3）
          RESOURCE_LIBRARY_OPEN_FILE_TAB: { value: 3 },
          // 访问技能管理 / MCP / 定时任务 / 消息频道 / 数据库等配置页（020-14-5）
          CONFIG_PAGE_VISIT: { value: 5 },
          // 右侧常用技能栏技能点击（020-14-6）
          SKILL_SHORTCUT_BAR_CLICK: { value: 6 },
          // 技能详情弹窗点击「对话使用」（020-14-7）
          SKILL_DETAIL_USE_IN_CONVERSATION: { value: 7 },
          // 技能页「创建技能」-「对话创建」（020-14-9）
          CREATE_SKILL_BY_CONVERSATION: { value: 9 },
          // 研究模式文档分享（020-14-10）
          DOCUMENT_SHARE: { value: 10 },
          // 输入框上下文用量环形入口 hover（020-14-11）
          CONTEXT_USAGE_HOVER: { value: 11 },
          // 输入框「立即整理」按钮点击（020-14-12）
          CONTEXT_ORGANIZE_CLICK: { value: 12 },
          // 文档页相关 AI 会话入口/浮窗展示（020-14-14）
          RELATED_AI_SESSIONS_VIEW: { value: 14 },
          // 文档页相关 AI 会话浮窗点击（020-14-15）
          RELATED_AI_SESSIONS_CLICK: { value: 15 },
          // 历史记录页触发关联文档筛选（020-14-16）
          HISTORY_RELATED_DOC_FILTER: { value: 16 },
          // 资料库：点击批量管理入口（020-14-17）
          BATCH_MANAGE_ENTRY: { value: 17 },
          // 资料库：点击批量下载 icon（020-14-18）
          BATCH_DOWNLOAD_CLICK: { value: 18 },
          // 资料库：点击批量移动 icon（020-14-19）
          BATCH_MOVE_CLICK: { value: 19 },
          // 资料库：点击批量删除 icon（020-14-20）
          BATCH_DELETE_CLICK: { value: 20 },
          // MCP 授权页：点击同意授权（020-14-21）
          MCP_OAUTH_AUTHORIZE_CLICK: { value: 21 },
          // MCP 授权登录页：点击登录按钮（020-14-22）
          MCP_OAUTH_LOGIN_CLICK: { value: 22 },
          // HTML 编辑：AI 修改确定并生成批注（020-14-23）
          HTML_AI_EDIT_CONFIRM: { value: 23 },
          // HTML 编辑：人工修改确定（020-14-24）
          HTML_MANUAL_EDIT_CONFIRM: { value: 24 },
          // HTML 编辑：点击撤销（020-14-25）
          HTML_UNDO_CLICK: { value: 25 },
          // HTML 编辑：点击恢复（020-14-26）
          HTML_REDO_CLICK: { value: 26 },
          // HTML 编辑：点击清空批注（020-14-27）
          HTML_CLEAR_ANNOTATIONS_CLICK: { value: 27 },
          // 历史记录面板：会话置顶 / 取消置顶（020-14-28）
          HISTORY_SESSION_PIN: { value: 28 },
          // 定时任务：点击任务模板（020-14-30）
          SCHEDULED_TASK_TEMPLATE_CLICK: { value: 30 },
          // 定时任务：从模板修改后点击保存（020-14-31）
          SCHEDULED_TASK_TEMPLATE_SAVE: { value: 31 },
          // 资料库：点击收藏按钮（020-14-32）
          FAVORITE_BUTTON_CLICK: { value: 32 },
          // 资料库：点击收藏列表任一文件（020-14-33）
          FAVORITE_LIST_FILE_CLICK: { value: 33 },
          // 资料库：点击最近浏览列表任一文件（020-14-34）
          RECENT_LIST_FILE_CLICK: { value: 34 }
        }
      },
      // MCP 多密钥管理（020-20-*）。必须挂在 AI_CHAT 下，与 MCP_KEY_TRACK 的路径 AI_CHAT.child.MCP_KEY.child.* 对齐
      MCP_KEY: {
        value: 20,
        child: {
          // 配置视图选择已有密钥并完成切换（020-20-1）
          KEY_SELECT: { value: 1 },
          // 粘贴密钥并完成格式及权限校验（020-20-2）
          KEY_PASTE: { value: 2 },
          // 复制密钥 / MCP 配置 / Agent 指令（020-20-3）
          CONFIG_COPY: { value: 3 },
          // 提交新建密钥并收到服务端结果（020-20-4）
          KEY_CREATE: { value: 4 },
          // 行内修改密钥名称并保存完成（020-20-5）
          KEY_RENAME: { value: 5 },
          // 提交额度类型或配置总额调整（020-20-6）
          KEY_QUOTA_ADJUST: { value: 6 },
          // 完成停用或启用操作（020-20-7）
          KEY_STATUS_CHANGE: { value: 7 },
          // 二次确认删除并收到服务端结果（020-20-8）
          KEY_DELETE: { value: 8 },
          // 点击刷新且最新额度、状态和权限摘要加载完成（020-20-9）
          KEY_REFRESH: { value: 9 },
          // 从主视图、能力卡、管理列表或新建弹窗点击权限配置入口（020-20-10）
          PERMISSION_ENTRY_CLICK: { value: 10 },
          // 在全部工具与指定工具之间切换（020-20-12）
          PERMISSION_MODE_CHANGE: { value: 12 },
          // 点击密钥弹窗内左侧工具分组（020-20-13）
          PERMISSION_GROUP_SELECT: { value: 13 },
          // 全选或取消当前分组全部工具（020-20-15）
          PERMISSION_SELECT_GROUP: { value: 15 },
          // 保存权限并收到服务端成功或失败结果（020-20-16）
          PERMISSION_SAVE: { value: 16 },
          // 按当前密钥权限复制配置或 Agent 指令（020-20-18）
          AUTHORIZED_CONFIG_COPY: { value: 18 },
          // 二次确认重置默认密钥并收到服务端结果（020-20-19，需求文档埋点表暂未定义，编号待产品确认）
          KEY_RESET: { value: 19 }
        }
      }
    }
  },
  // 研究模式分享预览页 page=80（产品约定 80-14-x，免登录 H5/Web；与 AI_CHAT.TASK_MODE_RESEARCH（020-14-*）区分）
  RESEARCH_DOCUMENT_SHARE: {
    value: '80',
    child: {
      // 研究模式（与产品表第二段 14 对齐）
      PREVIEW: {
        value: 14,
        child: {
          // 80-14-1 研究模式-查看分享预览页面
          PAGE_VIEW: { value: 1 },
          // 80-14-2 研究模式-预览页面下载
          PAGE_DOWNLOAD: { value: 2 }
        }
      }
    }
  },
  // 导航栏工具
  NAVBAR_TOOLS: {
    value: '021',
    child: {
      // AI分身（1）
      AI_TWIN: {
        value: 1,
        child: {
          // 导航栏的AI分身按钮
          NAV_BUTTON: { value: 1 },
          // 主页面全部纪要按钮
          ALL_SUMMARY: { value: 2 },
          // 主页面批量删除按钮
          BATCH_DELETE: { value: 3 },
          // 主页面收起按钮
          COLLAPSE: { value: 4 },
          // 主页面添加参会按钮
          ADD_PARTICIPANT: { value: 5 },
          // 批量提交的筛选项
          BATCH_SUBMIT_FILTER: { value: 6 },
          // 自动展开状态开关
          AUTO_EXPAND_SWITCH: { value: 7 },
          // 主动提交AI分身按钮
          ACTIVE_SUBMIT: { value: 8 },
          // 仅看单独提交筛选
          SINGLE_SUBMIT_FILTER: { value: 9 },
          // 自动报名开关
          AUTO_REGISTER_SWITCH: { value: 10 },
          // 列表操作纪要
          LIST_OPERATION_SUMMARY: { value: 11 },
          // 列表操作删除
          LIST_OPERATION_DELETE: { value: 12 }
        }
      },
      // 录会（2）
      RECORD_MEETING: {
        value: 2,
        child: {
          // 导航栏的录会按钮
          NAV_BUTTON: { value: 1 },
          // 主页面全部纪要按钮
          ALL_SUMMARY: { value: 2 },
          // 主页面批量删除按钮
          BATCH_DELETE: { value: 3 },
          // 主页面收起按钮
          COLLAPSE: { value: 4 },
          // 主页面添加录会按钮
          ADD_RECORD: { value: 5 },
          // 会议录制提交按钮
          SUBMIT: { value: 6 },
          // 自动展开状态开关
          AUTO_EXPAND_SWITCH: { value: 7 },
          // 列表操作纪要
          LIST_OPERATION_SUMMARY: { value: 8 },
          // 列表操作删除
          LIST_OPERATION_DELETE: { value: 9 },
          // 列表查看会议信息
          LIST_VIEW_MEETING_INFO: { value: 10 }
        }
      },
      // 转写（3）
      TRANSCRIPTION: {
        value: 3,
        child: {
          // 导航栏的转写按钮
          NAV_BUTTON: { value: 1 },
          // 主页面全部纪要按钮
          ALL_SUMMARY: { value: 2 },
          // 主页面批量删除按钮
          BATCH_DELETE: { value: 3 },
          // 主页面收起按钮
          COLLAPSE: { value: 4 },
          // 主页面添加转写按钮
          ADD_TRANSCRIPTION: { value: 5 },
          // 转写提交按钮
          SUBMIT: { value: 6 },
          // 自动展开状态开关
          AUTO_EXPAND_SWITCH: { value: 7 },
          // 列表操作查看
          LIST_OPERATION_VIEW: { value: 8 },
          // 列表操作重试
          LIST_OPERATION_RETRY: { value: 9 },
          // 列表操作下载
          LIST_OPERATION_DOWNLOAD: { value: 10 },
          // 列表操作重命名
          LIST_OPERATION_RENAME: { value: 11 },
          // 列表操作删除
          LIST_OPERATION_DELETE: { value: 12 }
        }
      },
      // 录音（4）
      RECORDING: {
        value: 4,
        child: {
          // 导航栏录音按钮
          NAV_BUTTON: { value: 1 },
          // 主页面全部纪要按钮
          ALL_SUMMARY: { value: 2 },
          // 主页面批量删除按钮
          BATCH_DELETE: { value: 3 },
          // 主页面收起按钮
          COLLAPSE: { value: 4 },
          // 主页面添加录音按钮
          ADD_RECORDING: { value: 5 },
          // 录音提交按钮
          SUBMIT: { value: 6 },
          // 自动展开状态开关
          AUTO_EXPAND_SWITCH: { value: 7 },
          // 列表操作查看
          LIST_OPERATION_VIEW: { value: 8 },
          // 列表操作重试
          LIST_OPERATION_RETRY: { value: 9 },
          // 列表操作下载
          LIST_OPERATION_DOWNLOAD: { value: 10 },
          // 列表操作重命名
          LIST_OPERATION_RENAME: { value: 11 },
          // 列表操作删除
          LIST_OPERATION_DELETE: { value: 12 }
        }
      },
      // 翻译（5）
      TRANSLATION: {
        value: 5,
        child: {
          // 导航栏的翻译按钮
          NAV_BUTTON: { value: 1 },
          // 主页面全部翻译按钮
          ALL_TRANSLATION: { value: 2 },
          // 主页面批量删除按钮
          BATCH_DELETE: { value: 3 },
          // 主页面收起按钮
          COLLAPSE: { value: 4 },
          // 主页面添加翻译按钮
          ADD_TRANSLATION: { value: 5 },
          // 翻译提交按钮
          SUBMIT: { value: 6 },
          // 自动展开状态开关
          AUTO_EXPAND_SWITCH: { value: 7 },
          // 列表操作查看
          LIST_OPERATION_VIEW: { value: 8 },
          // 列表操作重试
          LIST_OPERATION_RETRY: { value: 9 },
          // 列表操作下载
          LIST_OPERATION_DOWNLOAD: { value: 10 },
          // 列表操作删除
          LIST_OPERATION_DELETE: { value: 11 }
        }
      },
      // 工具栏应用点击汇总（7）021-7-1：点击顶部工具栏各项 icon
      TOOLBAR_APP: {
        value: 7,
        child: {
          // 点击顶部工具栏各项应用入口
          CLICK: { value: 1 }
        }
      }
    }
  },
  // 点评埋点
  COMMENT: {
    value: '022',
    child: {
      NAVMENU: {
        value: 0,
        child: {
          // 导航栏
          MENU_CLICK: { value: 1 }
        }
      },
      PAGE: {
        value: 1,
        child: {
          // 点评详情
          Comment_Detail: { value: 1 }
        }
      }
    }
  },
  // 试用会员
  MEMBER: {
    value: '024',
    child: {
      PAGE: {
        value: '0',
        child: {
          // 试用会员-点击立即领取
          DRAW: { value: '1' },
          // 试用会员-观看视频
          VIDEO: { value: '2' },
          // 试用会员-到期3天内-立即领取
          DAYS3: { value: '3' },
          // 试用会员-到期结束
          FINISH: { value: '4' },
          // 试用会员-保存至相册
          SAVEQRCODE: { value: '5' },
          // 试用会员-去填写
          FILLTEXT: { value: '7' },
          // 试用会员-点击增加（笔形录音机）
          CLICK_ADD: { value: '8' },
          // 试用会员- 试用会员领取成功-去添加
          MEMBER_ADD: { value: '9' },
          // 试用会员- 试用会员结束三天内-去添加
          MEMBER_3DAYS_ADD: { value: '10' },
          // 试用会员- 试用结束-立即购买
          MEMBER_PURCHASE: { value: '11' }
        }
      }
    }
  },
  // 舆情
  PUBLIC_OPINION: {
    value: '025',
    child: {
      // 微信平台
      WEIXIN_PLATE: {
        value: 1,
        child: {
          // 微信平台-切换tab
          TAB: { value: 1 },
          // 微信平台-预约
          Reservation: { value: 2 },
          // 微信平台-点击内容
          Detail: { value: 3 },
          // 微信平台-内容预约
          DetailAction: { value: 4 }
        }
      },
      // 舆情
      CLICK_CATEGORY: {
        value: 2,
        child: {
          // 群动态-切换tab
          TAB: { value: 1 },
          // 群动态-收藏
          ADD: { value: 2 },
          // 群动态-打开内容
          DATA: { value: 3 },
          // 群动态-预约成功
          APPOINTMENT_SUCCESS: { value: 4 },
          // 群动态-点击前往配置按钮
          OPEN_DATA: { value: 5 },
          // 群动态-点击复制链接按钮
          COPY_CONFIG_URL: { value: 6 },
          // 一键代录按钮点击
          AI_PROXY_RECORD: { value: 7 },
          // 025-2-8 最新排序选项点击
          LATEST_SORT: { value: 8 }
        }
      }
    }
  },

  // 会员专区
  MEMBER_ZONE: {
    value: '024',
    child: {
      // 会员专区主页
      MAIN: {
        value: '1',
        child: {
          // 024-1-1: 进入会员专区页面
          PAGE_VIEW: { value: '1' },
          // 024-1-2: 续费/购买按钮点击
          RENEW_PURCHASE: { value: '2' },
          // 024-1-3: 全部权益按钮点击
          ALL_BENEFITS: { value: '3' },
          // 024-1-4: 具体权益点击
          BENEFIT_ITEM: { value: '4' },
          // 024-1-5: 尊享内容tab
          EXCLUSIVE_TAB: { value: '5' },
          // 024-1-6: 尊享内容 - 路演
          EXCLUSIVE_ROADSHOW: { value: '6' },
          // 024-1-7: 尊享内容 - 调研
          EXCLUSIVE_SURVEY: { value: '7' },
          // 024-1-8: 尊享内容 - 内资研报
          EXCLUSIVE_REPORT: { value: '8' },
          // 024-1-9: 尊享内容 - 会议纪要
          EXCLUSIVE_MEETING_SUMMARY: { value: '9' },
          // 024-1-10: 尊享内容 - 调研纪要
          EXCLUSIVE_SURVEY_SUMMARY: { value: '10' },
          // 024-1-11: 尊享内容 - 外资研报
          EXCLUSIVE_FOREIGN_REPORT: { value: '11' },
          // 024-1-12: 尊享内容 - 专享点评
          EXCLUSIVE_COMMENT: { value: '12' },
          // AI问答（复用会议纪要的埋点编号）
          EXCLUSIVE_AI_QUESTION: { value: '9' },
          // 024-1-13: 专属推荐
          RECOMMEND_ITEM: { value: '13' },
          // 024-1-14: 已兑换内容tab
          EXCHANGED_TAB: { value: '14' },
          // 024-1-15: 已兑换内容 - 路演
          EXCHANGED_ROADSHOW: { value: '15' },
          // 024-1-16: 已兑换内容 - 调研
          EXCHANGED_SURVEY: { value: '16' },
          // 024-1-17: 已兑换内容 - 内资研报
          EXCHANGED_REPORT: { value: '17' },
          // 024-1-18: 已兑换内容 - 点评
          EXCHANGED_COMMENT: { value: '18' },
          // 024-1-19: 已兑换内容 - 调研纪要
          EXCHANGED_SURVEY_SUMMARY: { value: '19' },
          // 024-1-31: 专业版会员-权益展示-AI进宝
          PRO_BENEFIT_AI: { value: '31' },
          // 024-1-32: 专业版会员-权益展示-纪要
          PRO_BENEFIT_SUMMARY: { value: '32' },
          // 024-1-33: 专业版会员-权益展示-研报
          PRO_BENEFIT_REPORT: { value: '33' },
          // 024-1-34: 机构版会员-权益展示-AI进宝
          ORG_BENEFIT_AI: { value: '34' },
          // 024-1-35: 机构版会员-权益展示-纪要
          ORG_BENEFIT_SUMMARY: { value: '35' },
          // 024-1-36: 机构版会员-权益展示-研报
          ORG_BENEFIT_REPORT: { value: '36' }
        }
      }
    }
  },

  // 搜索
  SEARCH: {
    value: '026',
    child: {
      // 搜索联想词
      HINT_WORD: {
        value: 1,
        child: {
          // 搜索联想词-弹出联想词列表
          SHOW_LIST: { value: 1 },
          // 搜索联想词-点击/选择联想词
          SELECT: { value: 2 },
          // 搜索联想词-直接搜索（未采纳联想词）
          DIRECT_SEARCH: { value: 3 }
        }
      },
      // 搜索结果
      SEARCH_RESULT: {
        value: 2,
        child: {
          // 搜索结果-详情
          DETAIL: { value: 1 }
        }
      },
      // BRM全局搜索
      GLOBAL_SEARCH: {
        value: 3,
        child: {
          // BRM全局搜索-AI搜索按钮-hover
          AI_SEARCH_HOVER: { value: 1 },
          // BRM全局搜索-AI搜索按钮-点击
          AI_SEARCH_CLICK: { value: 2 },
          // BRM全局搜索-传统搜索-回车
          TRADITIONAL_SEARCH_ENTER: { value: 3 }
        }
      },
      // BRM全局搜索-综合Tab
      GLOBAL_SEARCH_INTEGRATED: {
        value: 4,
        child: {
          // BRM全局搜索-综合Tab-搜索结果总结展示
          SUMMARY_SHOW: { value: 1 },
          // BRM全局搜索-综合Tab-深入探索按钮点击
          DEEP_EXPLORE_CLICK: { value: 2 }
        }
      },
      // BRM全局搜索-进宝Tab
      GLOBAL_SEARCH_AICHAT: {
        value: 5,
        child: {
          // BRM全局搜索-进宝Tab-进入
          ENTER: { value: 1 }
        }
      }
    }
  },

  // 事件信号
  EVENT_SIGNAL: {
    value: '027',
    child: {
      // 事件信号
      MAIN: {
        value: 1,
        child: {
          // 事件信号-点击
          CLICK: { value: 1 },
          // 事件信号-跳转个股
          STOCK_DETAIL: { value: 2 },
          // 事件信号-个股加自选
          FOLLOW: { value: 3 },
          // 事件信号-记录搜索
          SEARCH: { value: 4 },
          // 事件信号-记录筛选
          FILTER: { value: 5 },
          // 事件信号-溯源跳转
          SOURCE: { value: 6 },
          // 事件信号-溯源更多
          SOURCE_MORE: { value: 7 },
          // 事件信号-自选概览信号tab
          SELFSELECTED_OVERVIEW: { value: 8 },
          // 事件信号-个股详情信号tab
          SELFSELECTED_STOCK_DETAIL: { value: 9 },
          // 事件信号-题材详情信号tab
          SELFSELECTED_THEME_DETAIL: { value: 10 },
          // 事件信号-行业详情信号tab
          SELFSELECTED_INDUSTRY_DETAIL: { value: 11 },
          // 事件信号-产品详情信号tab
          SELFSELECTED_PRODUCT_DETAIL: { value: 12 }
        }
      }
    }
  },
  // 自选分组
  GROUP_ID: {
    value: '028',
    child: {
      // 自选筛选
      FILTER: {
        value: 1,
        child: {
          // 列表选择自选组
          LIST: {
            value: 1
          },
          // 个股筛选选择自选股
          STOCK_LIST: {
            value: 2
          }
        }
      }
    }
  },
  // 调研活动 page=85（与移动端埋点编号保持一致，与上方 SURVEY 模块（09-*）特意区分，勿合并）
  RESEARCH_ACTIVITY: {
    value: '85',
    child: {
      DETAIL: {
        value: '1',
        child: {
          // 85-1-0 调研活动-详情-浏览
          BROWSE: { value: '0' }
        }
      }
    }
  },
  // 策略会 page=65（与移动端埋点编号保持一致，与上方 SURVEY.STRATEGY_VIEW_TIME（09-4-*）特意区分，勿合并）
  STRATEGY_MEETING: {
    value: '65',
    child: {
      DETAIL: {
        value: '1',
        child: {
          // 65-1-0 策略会-详情-浏览
          BROWSE: { value: '0' }
        }
      }
    }
  },
  // 业绩日历 page=64
  PERFORMANCE_CALENDAR: {
    value: '64',
    child: {
      CALENDAR: {
        value: 3,
        child: {
          // 64-3-3 日历-业绩日历-加入分身纪要
          ADD_AI_NOTE: { value: 3 },
          // 64-3-4 日历-业绩日历-结束状态查看分身纪要
          VIEW_AI_NOTE_SUMMARY: { value: 4 }
        }
      }
    }
  },
  // 日历 page=40（产品埋点编号；与 GLOBAL_MENU.child.CALENDAR（014-2 菜单入口）、SCHEDULE（03-*）区分，勿合并）
  CALENDAR: {
    value: '40',
    child: {
      // 日历-自动预约
      AUTO_BOOKING: {
        value: 0,
        child: {
          // 40-0-1 日历-自动预约
          CLICK: { value: 1 },
          // 40-0-2 日历-自动预约-点击提示前往设置
          GO_TO_SETTING: { value: 2 }
        }
      },
      // 日历-我的
      MINE: {
        value: 3,
        child: {
          // 40-3-3 日历-我的-自动分身参会
          AUTO_AI_TWIN_ATTEND: { value: 3 },
          // 40-3-4 日历-我的-显示我的路演
          SHOW_MY_ROADSHOWS: { value: 4 },
          // 40-3-5 日历-我的-我的路演查看更多
          MY_ROADSHOWS_VIEW_MORE: { value: 5 },
          // 40-3-6 日历-我的-仅看手动预约
          ONLY_MANUAL_APPOINTMENT: { value: 6 },
          // 40-3-7 日历-我的日程-点击加入分身参会
          ADD_AI_TWIN_ATTEND: { value: 7 },
          // 40-3-8 日历-我的日程-结束状态查看分身纪要（AI分身图标）
          VIEW_AI_NOTE_SUMMARY: { value: 8 },
          // 40-3-9 日历-我的日程-分身摘要展开全部
          EXPAND_AI_NOTE_SUMMARY: { value: 9 },
          // 40-3-10 日历-我的日程-分身摘要查看分身纪要
          VIEW_AI_SUMMARY_DOCUMENT: { value: 10 }
        }
      }
    }
  }
};

// 埋点事件类型
export const TRACK_EVENT_TYPE = {
  // 点击
  CLICK: 1,
  // 搜索
  SEARCH: 2,
  // 浏览
  BROWSE: 3,
  // 筛选
  FILTER: 4,
  // 创建
  CREATE: 5
};

/**
 * @description 路径代码到埋点标识的映射
 */
export const codeToTrackMap = {
  // 内部联系人
  '/addressBook/internalContacts': 'ADDRESS_BOOK.child.INTERNAL_CONTACT',
  // 券商研究所
  '/addressBook/securitiesDealer': 'ADDRESS_BOOK.child.BROKERAGE_RE',
  // 系统设置 - 成员管理
  '/systemSetting/memberManage': 'ENTERPRISE_MANAGE.child.MEMBER_MANAGE',
  // 系统设置 - 成员推送
  '/contact/sync': 'ENTERPRISE_MANAGE.child.MEMBER_PUSH',
  // 系统设置 -合作券商
  '/systemSetting/cooperateBrokerage/list': 'ENTERPRISE_MANAGE.child.COOPERATION_BROKERAGE',
  // 系统设置 - 机构设置
  '/systemSetting/organizationSetting': 'ENTERPRISE_MANAGE.child.ORG_SETTING',
  // 系统设置 - 合作权益
  '/systemSetting/memberRights/list': 'ENTERPRISE_MANAGE.child.COOPERATION',
  // 系统设置 - 券商会议
  '/systemSetting/meetingPush/config': 'ENTERPRISE_MANAGE.child.BROKERAGE_MEETING',
  // 系统设置 - 会议授权
  '/meeting-account/binding': 'ENTERPRISE_MANAGE.child.MEETING_AUTHORIZATION',
  // 系统设置 - 数据统计
  '/statistics/list': 'ENTERPRISE_MANAGE.child.DATA_STATISTICS',

  // 云文档
  '/document': 'CLOUDDOCUMENT.child.MY_SPACE',
  // 云文档 - 我的空间
  '/document/mySpace': 'CLOUDDOCUMENT.child.MY_SPACE',
  // 云文档 - 我的笔记
  '/document/mySpace/note': 'CLOUDDOCUMENT.child.MY_SPACE.child.FOLDER',
  // 云文档 - AI会记
  '/document/mySpace/aiNote': 'CLOUDDOCUMENT.child.MY_SPACE.child.FOLDER',
  // 云文档 - 会议纪要
  '/document/mySpace/meetingNote': 'CLOUDDOCUMENT.child.MY_SPACE.child.FOLDER',

  // ========== 菜单栏埋点 ==========
  // AI进宝
  '/aiChat/index': 'AI_CHAT.child.HOME.child.MENU',

  // 自选
  '/market/self-selected': 'SELFSELECTED.child.NAVMENU.child.MENU_CLICK',

  // 纪要
  '/summary/list': 'SUMMARYDETAIL.child.LIST.child.MENU_CLICK',

  // 点评
  '/comment/index': 'COMMENT.child.NAVMENU.child.MENU_CLICK',
  // 问答
  '/question/list': 'QUESTION.child.MODULE_QUESTION.child.MENU_CLICK',

  // 活动 014-1
  '/activity/roadshow': 'GLOBAL_MENU.child.ACTIVITY',
  // 日历 014-2
  '/scheduleManage/list': 'GLOBAL_MENU.child.CALENDAR',
  // 云文档 014-3
  '/document/cloudIndex': 'GLOBAL_MENU.child.CLOUD_DOCUMENT',
  // 洞察 014-4
  '/market/list': 'GLOBAL_MENU.child.INSIGHT',
  // 研报 014-5
  '/reportManage/index': 'GLOBAL_MENU.child.RESEARCH_REPORT',
  // 资讯 014-6
  '/news/list': 'GLOBAL_MENU.child.NEWS',
  // 管理 014-7
  'systemSetting:directory': 'GLOBAL_MENU.child.MANAGE',
  // 通讯录 014-8
  'addressBook:directory': 'GLOBAL_MENU.child.ADDRESS_BOOK',
  // 微信群 014-10
  '/publicOpinion/index': 'GLOBAL_MENU.child.WECHAT_GROUP',
  // SRS工作台 014-11
  '/workbench/index': 'GLOBAL_MENU.child.SRS_WORKBENCH'
};
